import "./App.css";
import Header from "./Components/Header/Header";
import Landing from "./Components/Landing/Landing";
import Work from "./Components/Work/Work";
import About from "./Components/About/About";
import ServicesStrip from "./Components/ServicesStrip/ServicesStrip";
import Footer from "./Components/Footer/Footer";

function App() {
  return (
    <div className="App">
      {/* <Wrapper /> */}
      <Header />
      <Landing />
      <Work />
      <div className="contact-screen">
        <About />
        <ServicesStrip />
        <Footer />
      </div>
    </div>
  );
}

export default App;
